import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { IntroComponent } from 'src/app/sas/intro/intro.component';
import { Globals } from 'src/app/shared/services/globals';

@Component({
  selector: 'app-Home-preview',
  templateUrl: './Home-preview.component.html',
  styleUrls: ['./Home-preview.component.css']
})
export class HomePreviewComponent implements OnInit {

  constructor(public global: Globals , private dialog: MatDialog) { }

  ngOnInit() {
    if(this.global.Role == "PATIENT"){
      let dialogRef = this.dialog.open(IntroComponent , {
        hasBackdrop:true,
        autoFocus:true,
        width: "60%"
      });
    }

  }

}
